export enum USER_TYPES {
	Administrator = 1,
	Participant = 2,
	Supervisor = 3,
	Advisor = 4,
	AdminWithOverride = 5,
	RestrictedParticipant = 6,
	ClientAdministrativeAccess = 7,
	ProxyApplicationCreator = 8,
	FranchiseOperator = 9,
	ApplicationTeam = 10,
	FranchiseProxy = 11,
	FranchiseLiaison = 12,
	ApplicationTeamWithOverride = 15, //called as Payment Administrator
	PaymentTeam = 20,
	PaymentTeamWithOverride = 25,
	TuitionSpecialist = 30,
	TuitionSpecialistWithOverride = 35,
	ResearchSpecialist = 40,
	ResearchSpecialistWithOverride = 45,
	CustomerCareMgmt = 50,
	CustomerCareMgmtWithOverride = 55,
	ClientRelations = 60,
	ClientRelationsWithOverride = 65,
	CustomerCareRep = 70,
	CustomerCareRepWithOverride = 75,
	SystemAdmin = 80,
	SystemAdminWithOverride = 85,
	BatchSystemUser = 90
}
